"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotlistColumn = void 0;
const HotlistUnit_1 = require("./HotlistUnit");
const propertyMapping = {
    change: 'isChange',
    id: 'id',
    resource: 'resourceKey',
    selectable: 'isSelectable'
};
class HotlistColumn {
    constructor(obj) {
        let targetProperty;
        for (const prop in obj) {
            switch (prop) {
                case 'units':
                    this.unit = (0, HotlistUnit_1.getHotlistUnit)(obj[prop]);
                    break;
                default:
                    targetProperty = propertyMapping[prop];
                    if (targetProperty) {
                        this[targetProperty] = obj[prop];
                    }
                    break;
            }
        }
    }
}
exports.HotlistColumn = HotlistColumn;
//# sourceMappingURL=HotlistColumn.js.map